// import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import $ from 'jquery';
import {AllModules} from '@ag-grid-enterprise/all-modules';
import { AgGridReact } from 'ag-grid-react';
// import { fetchGridLayout } from '../../../../legrand_node/routes/controller/trackingController.js';
import { fetchGridLayout } from '../common/utils.js';
import { getHyphenDDMMMYYYYHHMM, getHyphenDDMMYYYYHHMMSS } from '../common/utils.js';
import React, { Component } from 'react';
import Select from 'react-select';
import ResendConsentRenderer from './ResendConsentRenderer.js'
import IVRLogsRenderer from './IVRLogsRenderer.js'
import EditSimTracking from './editsimtracking.js'
import SIMTrackingCounters from './simtrackingCounters.js';

// import AttendedButtonRenderer from './AttendedButtonRenderer.js';

// import _ from "lodash";
// import ResendConsentRenderer from './ResendConsentRenderer.js'
import AttendedRenderer from './AttendedRenderer.js';

import redirectURL from "../redirectURL.js";
export const validPhone = new RegExp(/^[0-9]{10}$/);
export const validMobile = new RegExp(/^[6789]\d{9}$/);

export default class SimTrack extends Component {

	constructor(props) {
		super(props);
		this.state = {
			modules: AllModules,
			pageTitle: "SIM Tracking",
			eventGridAction: "gridAction",
			eventCounterAction: "counterAction",
			eventFormAction: "formAction",
			rowData: [],
			uploadDivWidth: '0%',
			sliderTranslate: '',
			loadshow: 'show-n',
			overly: "show-n",
			alertshow: 'fade',
			alertmg: 'show-n',
			alerterrmg: 'show-n',
			alerterrshow: 'fade',
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			usermanualmodal: false,
			sliderAddTransporter: "",
			sliderUpdateShipment : "",
			transporter_name: "",
			transporter_code: "",
			rowid: "",
			utransporter_name: "",
			utransporter_code: "",
			rowModelhighchartoptionsType: 'enterprise',
			rowGroupPanelShow: 'always',
			animateRows: true,
			debug: true,
			showToolPanel: false,
			rowSelection: "single",
			context: { componentParent: this },

			loadingCellRenderer: "customLoadingCellRenderer",
			loadingCellRendererParams: { loadingMessage: "One moment please..." },


			rowModelType: "serverSide",
			paginationPageSize: 50,
			statusBar: {
				statusPanels: [
				  {
					statusPanel: "agTotalAndFilteredRowCountComponent",
					align: "left"
				  },
				  {
					statusPanel: "agTotalRowCountComponent",
					align: "center"
				  },
				  { statusPanel: "agFilteredRowCountComponent" },
				  { statusPanel: "agSelectedRowCountComponent" },
				  { statusPanel: "agAggregationComponent" }
				]
			  },
			  sideBar: {
				toolPanels: [
				  {
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel"
				  },
				  {
					id: "filters",
					labelDefault: "Filters",
					labelKey: "filters",
					iconKey: "filter",
					toolPanel: "agFiltersToolPanel"
				  }
				]
			  },
			cacheBlockSize: 10,
			maxBlocksInCache: 1,
			sliderEditTransporter: "",

			consignee_name: "",
			consignee_code: "",
			lat: "",
			lng: "",
			for_code: "",
			driver_code: "",
			driver_name: "",
			assigned_truck_no: { "value": "", "label": "Select" },
			is_active: "",
			trucks: [],
			allShipmentRows : [],
			check_domain : /enmovil\.in/,
			check_Dup : false,
			mobile_no: "",
			mobile_no_find: "",
			err_mobile: "",
			rowDataActive: [],
			truckNoList: [],
			username:'',
			email:'',
			filteredData: [],
			showTrucksList: "show-n",
			allrowData: [],
			sliderForceCloseTranslate: "",
			sliderForSimLogs:"",
			simoperator_value: "",
			resendcontent: "",
			errmsg: false,
			mobile_network: { label: 'NON-JIO', value: 'non_jio' },
			detailCellRendererParams:{},
			defaultColDef: {
				sortable: true,
				filter: true,
				resizable: true
			},
			// mobile_networks: [{ label: "Airtel", value: "airtel" }, { label: "Reliance Jio", value: "jio" }, { label: "BSNL ", value: "bsnl" },{ label: "Vodafone Idea ", value: "vi" }],
			sim_tracking_service_provider: [{ label: "JIO", value: "jio" }, { label: "NON-JIO", value: "non_jio" }],
			truckslist: [],
			transporters: [],
			transporterslist: [],
			username:"",
			SIMCounters: {
				totalData:0,
				consentNotRegistered:0,
				consentPending: 0,
				consentDeclined:0,
				consentApproved:0,
			},
			totalData:[],
			consentNotRegisteredData:[],
			consentPendingData:[],
			consentApprovedData:[],
			consentDeclinedData:[],
			counterActive:"Total"
				}
		this.OnLoadDrivers = this.OnLoadDrivers.bind(this);
		this.changeMobileNoHandler = this.changeMobileNoHandler.bind(this);
		this.onClickEditBlock = this.onClickEditBlock.bind(this);
		this.resetState = this.resetState.bind(this);
		this.resetPageData = this.resetPageData.bind(this);
		this.onCountersData = this.onCountersData.bind(this);
	}
	// logPageView = () => {
	// 	try {
	// 		if (googleAnalytics.page.enableGA) {
	// 			googleAnalytics.logPageView();
	// 			let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
	// 			let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
	// 			let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
	// 			this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
	// 		} else {
	// 		}
	// 	} catch(error) {
	// 	}
	// }

	componentDidMount() {
		/*Consignments List*/
		//  this.logPageView(); // Log page view to GA
		// let eventAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
		// this.setState({eventAction: eventAction});
		const decipher = salt => {
			const textToChars = text => text.split('').map(c => c.charCodeAt(0));
			const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
			return encoded => encoded.match(/.{1,2}/g)
				.map(hex => parseInt(hex, 16))
				.map(applySaltToChar)
				.map(charCode => String.fromCharCode(charCode))
				.join('');
		}
		const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
		var user = ''
		try {
			user = JSON.parse(decode(localStorage.getItem("k")))
			this.setState({
				username: user.username,
				email: user.email
			})
		}
		catch (err) {

		}
		// console.log(this.state.username,"username");
		
		var truckitems = [];
		var items = [];
		redirectURL.post('/trucks')
			.then((response) => {
				var records = response.data;
				this.setState({
					trucks: records
				},()=>{
					if (this.state.trucks.length > 0) {
						this.state.trucks.map((item) => {
							truckitems.push({
								value: item.truck_no,
								label: item.truck_no
							})
						})
						this.setState({
							truckslist: truckitems
						}, ()=>{
						})
					}
				});
			})
			.catch(function (error) {
			});

		redirectURL.post('/transporterlist')		
			.then((response) => {
				var records = response.data.records;
				// console.log(records,"records");
				let filteredRecords = records.filter(item => item.transporter_type === "FTL");
				// console.log(filteredRecords,"filteredRecords");
				
				if (filteredRecords.length > 0) {
					
					filteredRecords.map((item) => {
						items.push({
							value: item.transporter_name,
							label: item.transporter_name
						})
					})
					this.setState({
						transporterslist: items
					})
				}
			})
			.catch(function (error) {
			});


		// redirectURL.post("/usergridstates", { userId: localStorage.getItem("userid"), screenurl: window.location.pathname })
		// 	.then(async (resp) => {
		// 		await this.setState({
		// 			usergridstate: resp.data
		// 		});
		// 		await this.restoreGridStates();
		// 	});
		this.OnLoadDrivers();
		this.showShipmentIdsPopup();
		var trucks = this.state.trucks;
		
	};
	componentDidUpdate(prevProps, prevState) {
		// Check if counterActive has changed
		if (prevState.counterActive !== this.state.counterActive) {
			console.log("counterActive changed:", this.state.counterActive);
			this.OnLoadDrivers(); // Call the OnLoadDrivers function
		}
	}
	onCountersData(records){
		var	consentNotRegisteredRecords = records.filter(e=>[1, 2, 5, 14, 13].includes(e.last_consent_status) )
				var	consentPendingRecords = records.filter(e=>[6, 11, 22].includes(e.last_consent_status) )
				var	consentDeclinedRecords = records.filter(e=>[8, 10].includes(e.last_consent_status) )
				var	consentApprovedRecords = records.filter(e=>[3,18, 4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26, 9].includes(e.last_consent_status) )
				// console.log(consentNotRegisteredRecords.length, "9988899notregisterd");
				var totalRecords = [...consentNotRegisteredRecords, ...consentPendingRecords, ...consentDeclinedRecords, ...consentApprovedRecords]
				this.setState({
					totalData: totalRecords,
					consentNotRegisteredData:consentNotRegisteredRecords,
					consentPendingData: consentPendingRecords,
					consentApprovedData : consentApprovedRecords,
					consentDeclinedData : consentDeclinedRecords,
					SIMCounters: {
						totalData:totalRecords.length,
						consentNotRegistered: consentNotRegisteredRecords.length,
						consentPending: consentPendingRecords.length,
						consentDeclined: consentDeclinedRecords.length,
						consentApproved: consentApprovedRecords.length

					}
				})
				var rowDataActive = records.filter((e) => e.is_active === 1);
				// if (records.length > 0) {
				// 	var trucks = records.map(function (e) {
				// 		if (e.assigned_truck_no !== "") {
				// 			return e.assigned_truck_no;
				// 		}
				// 	})
				// 	.filter(function (value, index, self) {
				// 		return self.indexOf(value) === index;
				// 	});

				// 	this.setState({
				// 		truckNoList: trucks
				// 	})
				// 	console.log(trucks, "909000trucks");
					
				// }
				var isValidRecords = records.length>0;

				

				if (isValidRecords) {
					// console.log(this.state.counterActive, "counterActive331");
				
					var trucks = records
						.filter((e) => {
							// Define the statuses based on counterActive
				
							let statuses = [];
							if(this.state.counterActive === "Total"){
								statuses = [1, 2, 14, 5, 13, 6, 11, 22, 3, 18, 4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26, 9, 8, 10];
							}
							else if (this.state.counterActive === "Mobile No Not Registered") {
								statuses = [1, 2, 14, 5, 13];
							} else if (this.state.counterActive === "Consent Pending") {
								statuses = [6, 11, 22];
							} else if (this.state.counterActive === "Consent Approved") {
								statuses = [3, 18, 4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26, 9];
							} else if (this.state.counterActive === "Consent Declined") {
								statuses = [8, 10];
							}
				
							// Filter based on the statuses and assigned_truck_no
							return (
								statuses.includes(e.last_consent_status) &&
								e.assigned_truck_no !== ""
							);
						})
						.map((e) => e.assigned_truck_no)
						.filter((value, index, self) => self.indexOf(value) === index); // Ensure unique values
				
					// console.log(trucks, "filtered_trucks");
				
					this.setState({
						truckNoList: trucks,
					});
				}
				let records1 = [];
				if (this.state.counterActive === "Total") {
					records1 = totalRecords;
				}
				else if (this.state.counterActive === "Mobile No Not Registered") {
					records1 = consentNotRegisteredRecords;
				} else if (this.state.counterActive === "Consent Pending") {
					records1 = consentPendingRecords;
				} else if (this.state.counterActive === "Consent Approved") {
					records1 = consentApprovedRecords;
				} else if (this.state.counterActive === "Consent Declined") {
					records1 = consentDeclinedRecords;
				}
				
				this.setState({
					// rowData: records,
					rowData: records1,
					rowDataActive: rowDataActive,
					allrowData: records1,
					loadshow: "show-n",
					overly: "show-n"
				});
	}
	OnLoadDrivers() {
		redirectURL.post('/simdrivers')
			.then((response) => {
				
				var records = response.data.drivers;
				// console.log(records, "records788989");
				this.onCountersData(records)

				
				
			})
			.catch(function (error) {
			});
	}
	showShipmentIdsPopup = () => {
		var allRows = []
		var params1 = {}
		// redirectURL.post('/activeShipmentIds', params1)
		// 	.then((response) => {
		// 		allRows = response.data.trucks;
		// 		// console.log("allROws", allRows.length)
		// 		this.setState({
		// 			allRows: allRows
		// 		});
		// 		if (allRows) {
		// 			const shipmentIds = allRows
		// 				.filter(row => row.existing_active_trip === 1)
		// 				.map(row => row.shipment_id);

		// 			const newShipmentRows = allRows.filter(row => row.existing_active_trip === 1)
		// 			const oldShipmentRows = newShipmentRows.flatMap(record => {
		// 				if (record.existing_active_shipments && Array.isArray(record.existing_active_shipments)) {
		// 					return record.existing_active_shipments;
		// 				}
		// 				return [];
		// 			});
		// 			const oldShipmentIds = oldShipmentRows

		// 			const params = {
		// 				oldShipmentRows: oldShipmentRows
		// 			}

		// 			redirectURL.post("/consignments/fetchDuplicateOldShipments", params)
		// 				.then((response) => {
		// 					const old_shipmentrecords = response.data.old_shipmentrecords

		// 					const correctedshipments = [];

		// 					newShipmentRows.forEach((item) => {
		// 						correctedshipments.push(item);

		// 						item.existing_active_shipments.forEach((shipment_id) => {
		// 							const shipment = old_shipmentrecords.find(record => record.shipment_id === shipment_id);
		// 							if (shipment) {
		// 								correctedshipments.push(shipment);
		// 							}
		// 						});
		// 					});


		// 					this.setState({
		// 						shipmentIds: shipmentIds,
		// 						oldShipmentIds: oldShipmentIds,
		// 						allShipmentRows: correctedshipments,
		// 					});
		// 				})
		// 				.catch((error) => {
		// 					console.error("Error fetching duplicate shipments:", error);
		// 				});
		// 			// console.log(shipmentIds.length, "length")
		// 			if (shipmentIds.length > 0) {
		// 				this.setState({
		// 					show: true,
		// 					check_Dup : true,
		// 					// basicTitle: `Active shipments with the same mobile number found: ${shipmentIds.join(', ')}`,
		// 					basicTitle: "Duplicate mobile numbers detected in active shipments. This can force close previous shipments, Please update the driver number and driver name for these duplicates",
		// 					basicType: "success"
		// 				});
		// 			}
		// 		}
		// 	})
		// 	.catch(function (error) {
		// 		console.log(error);
		// 	});
	};
	restoreGridStates() {
		if (this.state.usergridstate.length !== 0) {
			try {
				var windowstates = this.state.usergridstate;
				this.gridColumnApi.setColumnState(windowstates[0].gridcolumns);
				this.gridColumnApi.setColumnGroupState(windowstates[0].gridgroup);
				this.gridApi.setSortModel(windowstates[0].gridcolsort);
				this.gridApi.setFilterModel(windowstates[0].gridcolfilter);

			}
			catch (e) {

			}
		}
	}
	onShowUploadDiv = () => {
		this.setState({
			uploadDivWidth: '30%',
			sliderTranslate: "slider-translate",
			showDiv: 'show-m',
			csvmessage: '',
			csverrmessage: '',
		});
	}
	onCloseUploadDiv = () => {
		this.setState({
			uploadDivWidth: '0%',
			sliderTranslate: "",
			showDiv: 'show-n',
			uploadFile: '',
			file: '',
			csvmessage: '',
			csverrmessage: '',
		});
	}
	onCloseUserManualModal = () => {
		this.setState({ usermanualmodal: false });
	};

	onClickShowUserManaul = () => {
		this.setState({ usermanualmodal: true });
	};

	// onCloseUploadDiv = () => {
	// 	this.setState({
	// 		uploadDivWidth: '0%',
	// 		sliderAddTransporter: "",
	// 		showDiv: 'show-n',
	// 		uploadFile: '',
	// 		file: '',
	// 		csvmessage: '',
	// 		csverrmessage: '',
	// 		sliderEditTransporter: ""
	// 	});
	// }
	onClickHideAll() {
		this.setState({
			loadshow: 'show-n',
			overly: 'show-n',
			sliderAddTransporter: '',
			sliderForSimLogs: '',
			sliderEditTransporter: "",
			sliderForceCloseTranslate: "",
			driver_code: "",
			driver_name: "",
			mobile_no: "",
			assigned_truck_no: "",
			transporter_name:"",
			err_mobile:"",
			sliderUpdateShipment : "",
			mobile_network: { label: 'NON-JIO', value: 'non_jio' },
			check_Dup : false
		});

	}

	onGridReady1 = params => {
		this.gridApi1 = params.api;
	    // console.log("Grid is: ", params);
        this.gridColumnApi1 = params.columnApi;     
		
		fetchGridLayout(this.state.email, "SIM Tracking Numbers")
		.then(res => {
			if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
				setTimeout(async () => {
					params.columnApi.applyColumnState({
						state: res.data.data[0].columnState,
						applyOrder: true,
					})
				}, 1500);		
			}
		})
		.catch(err => console.log(err))   
	};
	

	onGridState1 = () =>{
        console.log(this.gridApi1);
        this.colState = this.gridColumnApi1.getColumnState();
        this.rowGroupState = this.gridColumnApi1.getRowGroupColumns();
        this.pivotColumns = this.gridColumnApi1.getPivotColumns();
        window.filterState = this.gridApi1.getFilterModel();
        this.gridApi1.setFilterModel(window.filterState);
    }
	onGridReady = params => {
		// console.log("Grid is ready", params); 
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
	};
	onClickSaveGridState = async () => {
		if (!this.gridApi1 || !this.gridColumnApi1) {
			console.error("Grid API is not initialized.");
			return;
		}
	
		// Use columnApi to get sorting information
		const sortState = this.gridColumnApi1.getColumnState()
			.filter(column => column.sort !== null) // Filter only sorted columns
			.map(column => ({ colId: column.colId, sort: column.sort }));
	
		window.colState = this.gridColumnApi1.getColumnState();
		window.groupState = this.gridColumnApi1.getColumnGroupState();
		window.filterState = this.gridApi1.getFilterModel();
	
		let screenpage = 'SIM Tracking Numbers';
	
		let reqparams = {
			email: this.state.email,
			page: 'SIM Tracking Numbers',
			colState: window.colState,
			gridgroup: window.groupState,
			gridcolsort: sortState, // Updated to use sortState
			gridcolfilter: window.filterState,
			userId: localStorage.getItem("userid"),
			screenurl: window.location.pathname,
			screentitle: screenpage
		};
	console.log(reqparams,"reqparams");
		redirectURL.post("/saveAggridLayout", reqparams)
			.then((response) => {
				this.setState({
					show: true,
					basicTitle: "Successfully saved grid layout",
					basicType: "success",
					screenurl: window.location.pathname,
					screentitle: screenpage
				});
				window.location.reload()
			})
			.catch((e) => {
				console.error("Error saving grid states:", e);
			});
	};
	getRowStyle = (params) => {
        // if (params && params.data && params.data.existing_active_trip && params.data.existing_active_trip == 1) {
        //     return { backgroundColor: '#FFB9B9' }
        // }
        // else {
        //     return null
        // }
    }

	onClickGetSliderForUpdateShipment = () => {
		console.log("open slider for update shipments");
		
        this.setState({
            sliderUpdateShipment: "slider-translate-75p",
            show: false,
            showDiv: 'show-m',
            loadshow: 'show-n',
            // sidebarSubHeader: "Truck Information",
            overly: 'show-m',
        })
    }

	changeMobileNoHandler(event) {
		const value = event.target.value;
		const re = /^[0-9\b]+$/;
	
		// Check if the value is a valid number and meets the length criteria
		if ((value === '' || re.test(value)) && value.length <= 10) {
			this.setState({
				mobile_no: value,
				err_mobile: ""
			});
		} else if (value.length > 11) {
			this.setState({
				err_mobile: "Mobile number cannot exceed 10 digits"
			});
		}
	}
	OnBlurMobile(event) {
		var name = event.target.name;
		var value = event.target.value;

		const re = /^[0-9\b]+$/;

		if (value === "") {
			this.setState({ err_mobile: "Please enter mobile no", mobile_no: "" });
		}
		else {
			if ((re.test(value)) && (value.length < 10)) {
				this.setState({ err_mobile: "Mobile number cannot be less than 10 digits", mobile_no: "" });
			}
			else if ((value.length > 10)) {
				this.setState({ err_mobile: "Mobile number cannot exceed 10 digits", mobile_no: "" });
			}
		}

	}
	
	
	
	
	
	resetState = async() => {
		const sortState = this.gridColumnApi1.getColumnState()
			.filter(column => column.sort !== null) // Filter only sorted columns
			.map(column => ({ colId: column.colId, sort: column.sort }));
	
		window.colState = this.gridColumnApi1.getColumnState();
		window.groupState = this.gridColumnApi1.getColumnGroupState();
		window.filterState = this.gridApi1.getFilterModel();
	
		let screenpage = 'SIM Tracking Numbers';
	
		let reqparams = {
			email: this.state.email,
			page: 'SIM Tracking Numbers',
			colState: [],
		};
		console.log(reqparams,"reqparams");
		redirectURL.post("/saveAggridLayout", reqparams)
			.then((response) => {
				this.setState({
					show: true,
					basicTitle: "Successfully saved grid layout",
					basicType: "success",
					screenurl: window.location.pathname,
					screentitle: screenpage
				});
				window.location.reload()
			})
			.catch((e) => {
				console.error("Error saving grid states:", e);
			});
	};
	onCLickAddDriver() {
		this.setState({
			sliderAddTransporter: 'slider-translate-30p',
			overly: "show-m",
			driver_code: "",
			driver_name: "",
			mobile_no: "",
			assigned_truck_no: "",
			transporter_name: '',
			mobile_network:  { label: 'NON-JIO', value: 'non_jio' }
		});
	}
	changeHandler(event) {
		var name = event.target.name;
		var value = event.target.value;
		this.setState({ [name]: value });
	}
	showMarkers(event) {
		// if(event.target.value == 0)
		// {
		// 	this.setState({
		// 		showMarkers : 1
		// 	});
		// 	// viewMarkersArr.map(function(e){
		// 	// 	e.setVisible(true);
		// 	// })

		// }
		// else
		// {
		// 	this.setState({
		// 		showMarkers : 0
		// 	});
		// }

		this.setState({ simoperator_value: event.target.value })
	}
	newFilter = (filterType, selOption) => {
		this.setState({ [filterType]: selOption });
	}
	handleSubmit() {
		
		var param = this.state.resendcontent
		console.log(param,"consent params");
		
		if (this.state.mobile_network != "" && this.state.mobile_network != undefined) {
			param.sim_operator = this.state.mobile_network.value
			redirectURL.post("/resendconsent", param).then((response) => {
				if (response.data.status === "Success") {
					this.setState({
						show: true,
						basicTitle: response.data.message,
						basicType: "success",
						loadshow: "show-n",
						overly: "show-n",
						errmsg: false
					})
					this.OnLoadDrivers();
				}
				else {
					this.setState({
						show: true,
						basicTitle: response.data.message,
						basicType: "danger",
						loadshow: "show-n",
						overly: "show-n"
					})
				}
			})

		}
		else {
			this.setState({ errmsg: true })
		}

	}
	onClickHideForForceClosure() {
		this.setState({
			loadshow: 'show-n',
			overly: 'show-n',
			slideuploadeway: '',
			sliderRouteTranslate: '',
			sliderSegmentTranslate: "",
			tabsliderTranslate: '',
			sliderTranslatesidebar: '',
			sliderForceCloseTranslate: '',
			sliderCommentTranslate: "",
			bulkPrioritySlide: "",
			sliderForceCloseTranslate: ""
		});

	}
	onClickEditForm(rowdata) {
		var row = rowdata.data;
		var cordinates = JSON.parse(row.coordinates);
		var lat = cordinates.lat;
		var lng = cordinates.lng;
		this.setState({
			uconsignee_name: row.consignee_name,
			uconsignee_code: row.consignee_code,
			ulat: lat,
			ulng: lng,
			ufor_code: row.for_code,
			uconsignee_city: row.consignee_city,
			uconsignee_addr1: row.consignee_addr1,
			uconsignee_addr2: row.consignee_addr2,
			uconsignee_addr3: row.consignee_addr3,
			rowid: row._id,
			sliderEditTransporter: 'slider-translate',
			overly: "show-m"
		})
	}
	onChangeTruck(assigned_truck_no) {
		this.setState({ assigned_truck_no });
	}
	onChangeTransporter(transporter_name) {
		this.setState({ transporter_name });
	}
	saveDriverItem(event) {
		event.preventDefault();
		// var driver_code = this.state.driver_code;
		var transporter_name = this.state.transporter_name;
		var assigned_truck_no = this.state.assigned_truck_no;
		var driver_name = this.state.driver_name;
		var mobile_no = this.state.mobile_no;

		if (this.state.assigned_truck_no.value != "") {
			var assigned_truck_no = this.state.assigned_truck_no.value;
		}
		else {
			var assigned_truck_no = "";
		}
		if (this.state.transporter_name.value != "") {
			var transporter_name = this.state.transporter_name.value;
		}
		else {
			var transporter_name = "";
		}
		// var is_active = this.state.is_active;

		var params = {
			driver_name: driver_name,
			mobile_no: mobile_no,
			// sim_operator: this.state.mobile_network.value,
			assigned_truck_no: assigned_truck_no,
			transporter_name: transporter_name,
			user_name: this.state.username,
			// is_active:is_active
		}
		console.log(params,"params");
		
		if (assigned_truck_no !="" && mobile_no != "" && transporter_name!="" && assigned_truck_no !=undefined && mobile_no != undefined && transporter_name!=undefined) {
			this.setState({
				loadshow: "show-m",
				overly: "show-m"
			});
			redirectURL.post("/adddriver", params)
				.then((response) => {
					var resp = response.data
					if (response.data.status === "Success") {
						this.setState({
							show: true,
							basicTitle: "Driver details have been added successfully",
							basicType: "success",
							transporter_name: "",
							assigned_truck_no: "",
							is_active: 0,
							sliderAddTransporter: "",
							loadshow: "show-n",
							overly: "show-n",
							driver_name: '',
							mobile_no: '',
							username: '',
							mobile_network:  { label: 'NON-JIO', value: 'non_jio' }
						})
						this.OnLoadDrivers();
					}
					else {
						this.setState({
							show: true,
							basicTitle: response.data.message,
							basicType: "danger",
							loadshow: "show-n",
							overly: "show-n"
						})
					}


				})
		}else{
			console.log("mandatoryFields");
			
			this.setState({
				show:true,
				basicTitle: "Please enter mandatory fields",
				basicType: "danger"
			})
		}
	}
	onClickEditBlock(rownode) {
		console.log(rownode.data,"rownode");
		
		this.setState({
			sliderEditTransporter: 'slider-translate-30p',
			overly: "show-m",
			// driver_code: rownode.data.driver_code,
			driver_name: rownode.data.driver_name,
			mobile_no: rownode.data.driver_mobile_no,
			assigned_truck_no: { value: rownode.data.assigned_truck_no, label: rownode.data.assigned_truck_no },
			is_active: rownode.data.is_active,
			transporter_name: { value: rownode.data.transporter_name, label: rownode.data.transporter_name },
			// mobile_network: { value: rownode.data.sim_tracking_service_provider_name, label: rownode.data.sim_tracking_service_provider_name.replace(/_/g, '-').toUpperCase() },
			rowid: rownode.data._id
		})
	}
	updateDriverItem(event) {
		event.preventDefault();
		// var driver_code = this.state.driver_code;
		var driver_name = this.state.driver_name;
		var mobile_no = this.state.mobile_no;
		if (this.state.assigned_truck_no.value != "") {
			var assigned_truck_no = this.state.assigned_truck_no.value;
		}
		else {
			var assigned_truck_no = "";
		}
		if (this.state.transporter_name.value != "") {
			var transporter_name = this.state.transporter_name.value;
		}
		else {
			var transporter_name = "";
		}
		if (this.state.mobile_network.value != "") {
			var mobile_network = this.state.mobile_network.value;
		}
		else {
			var mobile_network =  { label: 'NON-JIO', value: 'non_jio' };
		}
		var is_active = this.state.is_active;

		var params = {
			// driver_code: driver_code,
			driver_name: driver_name,
			mobile_no: mobile_no,
			assigned_truck_no: assigned_truck_no,
			transporter_name: transporter_name,
			// mobile_network: mobile_network,
			is_active: is_active,
			rowid: this.state.rowid
			// for_code:for_code
		}
		console.log(params,"params");
		if (driver_name != "" && mobile_no != "") {
			redirectURL.post("/updatedriver", params)
				.then((response) => {
					if (response.data.status === "success") {
						this.setState({
							show: true,
							basicTitle: "Successfully updated driver",
							basicType: "success",
							// driver_code: "",
							driver_name: "",
							mobile_no: "",
							transporter_name: "",
							assigned_truck_no: "",
							// mobile_network:  { label: 'NON-JIO', value: 'non_jio' },
							is_active: 0,
							sliderEditTransporter: "",
							overly: "show-n"
						})
						this.OnLoadDrivers();
					}
					else {
						this.setState({
							show: true,
							basicTitle: response.data.message,
							basicType: "danger"
						})
					}

				})
		}
		else {
			this.setState({
				show: true,
				basicTitle: "All fields are mandatory",
				basicType: "danger"
			})
		}
	}
	closeAlert = () => {
		this.setState({
			show: false
		});

	}
	// closeAlert1 = async () => {
	//     await this.setState({
	//         show1: false
	//     });
	//     await window.location.reload()
	// }
	onCellClicked = async (params) => {
		if(params.colDef.field === "resend")
			{
				redirectURL.post("/resendconsent",params.data).then((response)=>{
					if(response.data.status == "Success")
					{
						this.setState({
							show:true,
							basicTitle:response.data.message,
							basicType:"success",
							loadshow:"show-n",
							overly:"show-n",
							errmsg:false
						})
						this.OnLoadDrivers();
					}
					else{
						this.setState({
							show:true,
							basicTitle:response.data.message,
							basicType:"danger",
							loadshow:"show-n",
							overly:"show-n"
						})
					}
				})
			}
		if (params.colDef.field == "verified") {
			// if(params.data.verified != 1)
			// {
			this.setState({
				loadshow: "show-m",
				overly: "show-m"
			})
			redirectURL.post("/verifyconsent", params.data).then((response) => {
				if (response.data.message === "Success") {
					this.setState({
						show: true,
						basicTitle: response.data.message,
						basicType: "success",
						loadshow: "show-n",
						overly: "show-n"
					})
					this.OnLoadDrivers();
				}
				else {
					this.setState({
						show: true,
						basicTitle: response.data.message,
						basicType: "danger",
						loadshow: "show-n",
						overly: "show-n"
					})
				}
			})
			// }
		}

		if(params.colDef.field == "logs")
			{
				
					this.setState({
						loadshow:"show-n",
						sliderForSimLogs : "slider-translate-60p",
						overly:"show-m"
					})
					console.log(params.data.driver_mobile_no,"mobile_no");
					
				redirectURL.post("/getSimLogsData", { mobile_no: params.data.driver_mobile_no }).then((response) => {
					var records = response.data
					if (records.length > 0) {
						var records = records.sort(GetSortDescOrder("created_date"))
						this.setState({
							sim_logs_data: records,
							// loadshow: "show-n",
						})
	
					} else {
						this.setState({
							sim_logs_data: [],
							// loadshow: "show-n",
						})
					}
				})
			}

		// if(params.colDef.field == "comment")
		// {
		// 	if(params.data.comment != "" && params.data.comment != undefined)
		// 	{
		// 		this.setState({
		// 			loadshow:"show-m",
		// 			overly:"show-m"
		// 		})
		// 		// redirectURL.post("/updateSIMTrackComment",params.data).then((response)=>{
		// 		// 	if(response.data.message == "Success")
		// 		// 	{
		// 		// 		this.setState({
		// 		// 			show:true,
		// 		// 			basicTitle:response.data.message,
		// 		// 			basicType:"success",
		// 		// 			loadshow:"show-n",
		// 		// 			overly:"show-n"
		// 		// 		})
		// 		// 		this.OnLoadDrivers();
		// 		// 	}
		// 		// 	else{
		// 		// 		this.setState({
		// 		// 			show:true,
		// 		// 			basicTitle:response.data.message,
		// 		// 			basicType:"danger",
		// 		// 			loadshow:"show-n",
		// 		// 			overly:"show-n"
		// 		// 		})
		// 		// 	}
		// 		// })
		// 	}
		// }
	}
	initalList = (event) => {
		$(".trucks-dropdown").removeClass("show-n");
		console.log(this.state.truckNoList, "truckNoList123");
		
		var dataset = this.state.truckNoList;
		dataset = dataset.slice(0, 100);
		this.setState({
			filteredData: dataset,
			showTrucksList: "show-m",
		})
	}
	changeHandlerForSearch = (event) => {
		var name = event.target.name;
		var value = event.target.value;
		console.log(name , "name")
		if(name == "mobile_no_find"){
			console.log("check_1729")
			const alphanumericRegex = /^\d+$/
			if ((alphanumericRegex.test(value) && value.length <11) || value == "") {
				this.setState({
					[name]: value
				})
			}else{
				this.setState(prevState => {
					[name] = [prevState]
				})
			}
		}else{
			this.setState({[name]:value});

		}
		
	}
	handlerForm = (event) => {
		// let name = event.target.name;
		// let value = event.target.value;
		// this.setState({[name]:value});
		$(".trucks-dropdown").removeClass("show-n");
		var dataset = this.state.truckNoList;
		var filteredResult = dataset.filter(function (e) {
			if (e != "" && e != null) {
				return e.toString().toLowerCase().includes($("#inputTruck").val().toLocaleLowerCase());
			}

		});
		filteredResult = filteredResult.slice(0, 100);
		var allrowData = this.state.allrowData;
		var rowData = allrowData.filter(function (e) {
			if (e.assigned_truck_no != "" && e.assigned_truck_no != null) {
				return e.assigned_truck_no.toString().toLowerCase().includes($("#inputTruck").val().toLocaleLowerCase());
			}

		})
		this.setState({
			filteredData: filteredResult,
			rowData: rowData,
			showTrucksList: "show-m",
		})
	}
	changeGPSStatus = () => {
		this.setState({
			loadshow: "show-m",
			overly: "show-m"
		});
		var allrowData = this.state.allrowData;
		var gps_status = $("#gps_status").val();
		var rowData = [];
		if (gps_status === 1 || gps_status === "1") {
			var rowData = allrowData.filter((ed) => ed.consent_status == "ACTIVE");
		}
		if (gps_status === 2 || gps_status === "2") {
			var rowData = allrowData.filter((ed) => ed.consent_status == "NOT FOUND");
		}
		if (gps_status === 3 || gps_status === "3") {
			var rowData = allrowData.filter((ed) => ed.consent_status == "PENDING");
		}
		if (gps_status === 0 || gps_status === "0") {
			var rowData = allrowData;
		}
		$("#inputTruck").val("")
		this.setState({
			rowData: rowData,
			loadshow: "show-n",
			overly: "show-n"
		});
	}
	formHandler = async (event) => {
		this.setState({
			loadshow: 'show-m'
		})
		event.preventDefault();
		var truckNo = $("#inputTruck").val().toUpperCase();
		var params = {}
		if (truckNo != undefined && truckNo != "") {
			params.assigned_truck_no = truckNo;
		}
		if(this.state.mobile_no_find != undefined && this.state.mobile_no_find != "") {
			params.mobile_no = this.state.mobile_no_find
		}
		if ((params.mobile_no === undefined) && (params.assigned_truck_no == undefined)) {
			this.setState({
				show:true , 
				basicType:"danger",
				basicTitle:"Please Enter Either Truck No Or Mobile No"
		})
		}
		// console.log(params,"params for search");
		// if (localStorage.getItem("plant_code") != undefined && localStorage.getItem("plant_code") != "" && localStorage.getItem("plant_code") != "undefined") {
		// 	params.plant_code = localStorage.getItem("plant_code");
		// }
		redirectURL.post('/simdrivers', params)
			.then((response) => {
				var records = response.data.drivers;
				this.onCountersData(records)
				this.setState({
					// rowData: records,
					loadshow: "show-n",
					overly: "show-n"
				});
				// this.OnLoadDrivers("")
			})
			.catch(function (error) {
				this.setState({
					loadshow: "show-n",
					overly: "show-n"
				});
			});
	}
	updateCellData(rownode) {
		if (rownode.colDef.field == "comment") {
			if (rownode.data.comment != "" && rownode.data.comment != undefined) {
				redirectURL.post("/updateSIMTrackComment", rownode.data).then((response) => {
					if (response.data.message == "Success") {
						this.setState({
							show: true,
							basicTitle: response.data.message,
							basicType: "success",
							loadshow: "show-n",
							overly: "show-n"
						})
						this.OnLoadDrivers();
					}
					else {
						this.setState({
							show: true,
							basicTitle: response.data.message,
							basicType: "danger",
							loadshow: "show-n",
							overly: "show-n"
						})
					}
				})
			}
		}
	}
	CounterClick=(ecounter) =>{
		// console.log(this.state.consentPendingData, "9990000");
		
		switch(ecounter){
			case "Total":
				this.setState({
					counterActive:ecounter,
					rowData:this.state.totalData 
				})
				break;
			case "Mobile No Not Registered":
				this.setState({
					counterActive:ecounter,
					rowData:this.state.consentNotRegisteredData 
				})
				break;
			case "Consent Pending":
				this.setState({
					counterActive:ecounter,
					rowData:this.state.consentPendingData
				})
				break;
			case "Consent Declined":
					this.setState({
						counterActive:ecounter,
						rowData:this.state.consentDeclinedData
					})
					break;	
			case "Consent Approved":
				this.setState({
						counterActive:ecounter,
						rowData:this.state.consentApprovedData
				})
				break;
			default:
                break;		


		}
	}
	resetPageData(){
		this.setState({
			mobile_no_find:"",
			assigned_truck_no: { "value": "", "label": "Select" },

		})
		this.OnLoadDrivers();
	}
	render() {
		const modalStyles = {
			width: '1300px !important',
		}
		var listData = []
		this.state.filteredData.map(function (e) {
			listData.push(<li className="dropdown-truck-no" id={e}>{e}</li>)
		})
		const columnwithDefs = [
			// {
			// 	headerName: "Action",
			// 	field: "_id",
			// 	resizable: true,
			// 	width: 120,
			// 	filter: false,
			// 	cellRenderer: EditSimTracking,
			// 	pinned: "left",
            //     headerClass: 'bold-header'
			// 	// editable: false
			// },
			// {
			// 	headerName: "IVR Logs",
			// 	field: "logs",
			// 	pinned: 'left',
			// 	resizable:true,
			// 	width: 100,
			// 	filter: false,
			// 	cellRenderer: IVRLogsRenderer,  
			// 	editable:false,
            //     headerClass: 'bold-header'
			//   },			
			// {
			// 	headerName: "Driver Name",
			// 	field: "driver_name",
			// 	width: 150,
			//     editable:false,
			// 	resizable:true,
			//     filter: true,
			//     pinned: "left",
            //     headerClass: 'bold-header'
			// },
			// {
			// 	headerName: "Driver Code",
			// 	field: "driver_code",
			// 	resizable: true,
			// 	width: 160,
			// 	editable: false,
			// 	filter: true,
			// 	pinned: "left"
			// },

			{
				headerName: "Mobile Number",
				field: "driver_mobile_no",
				resizable: true,
				width: 200,
				editable: false,
				filter: true,
				pinned: "left",
                headerClass: 'bold-header'
			},
			{
				headerName: "Mobile Operator",
				field: "sim_tracking_service_provider_name",
				resizable:true,
				width: 200,
				editable:false,
				filter: true,
				pinned: "left",
                headerClass: 'bold-header',
				valueGetter:function(params){
					if(params.data.sim_tracking_service_provider_name == "jio" ){
						return "JIO"
					}else if(params.data.sim_tracking_service_provider_name == "non_jio"){
						return "NON-JIO"
					}else{
						return ""
					}
				}
			},
			// 	  {
			// 		headerName: "Sim Tracking Service Provider",
			// 		field: "",
			// 	  resizable:true,
			// 		width: 110,
			// 	  editable:false,
			// 	  filter: true,
			// 	  pinned: "left",
			// 	  cellRenderer:function(params){
			// 		var mobile_num = params.data.driver_mobile_no 
			// 		var jioRegex = /^[78]\d{9}$/;
			// 		var is_checking = jioRegex.test(mobile_num); 
			// 		if(is_checking==true){
			// 			return "Jio"
			// 		}
			// 		else{
			// 			return "Non Jio"S
			// 		}

			// 	  }
			//   },



			{
				headerName: "Truck No",
				field: "assigned_truck_no",
				resizable: true,
				width: 130,
				editable: false,
				filter: true,
				pinned: "left",
                headerClass: 'bold-header'
			},
			// {
			// 	headerName: "Resend Consent",
			// 	field: "resend",
			// 	resizable: true,
			// 	width: 130,
			// 	filter: false,
			// 	cellRenderer: function (params) {
			// 		var htmloption = '<button style="padding:2% 10% 5% 10%" class="btn btn-info" title="Resend Consent">Resend</button>'
			// 		return htmloption;
			// 	},
			// 	editable: false
			// },
			{
				headerName: "Consent Status",
				field: "last_consent_status",
				resizable:true,
				width: 150,
				editable:false,
				valueGetter: function(params){
					try{
						if(params.data.last_consent_status == 1 || params.data.last_consent_status == 2||params.data.last_consent_status == 14 || params.data.last_consent_status == 5)
						{
							return "Not Registered";
						}
						if(params.data.last_consent_status == 3||params.data.last_consent_status == 18)
						{
							return "Approved";
						}
						if(params.data.last_consent_status == 4||params.data.last_consent_status == 7||params.data.last_consent_status == 12||
							params.data.last_consent_status == 15||params.data.last_consent_status == 16||
							params.data.last_consent_status == 17||params.data.last_consent_status == 19||
							params.data.last_consent_status == 20||params.data.last_consent_status == 21||
							params.data.last_consent_status == 23||params.data.last_consent_status == 24||
							params.data.last_consent_status == 25||params.data.last_consent_status == 26)
						{
							return "Consent Approved";
						}
						if(params.data.last_consent_status == 6 ||params.data.last_consent_status == 11||params.data.last_consent_status == 22)
						{
							return "Consent Pending";
						}
						if(params.data.last_consent_status == 8 ||params.data.last_consent_status ==10)
						{
							return "Consent Declined";
						}
						if(params.data.last_consent_status == 9 ||params.data.last_consent_status ==18)
						{
							return "Approved";
						}
						if(params.data.last_consent_status == 13)
						{
							return "Error";
						}
						if(params.data.last_consent_status == 14)
						{
							return "Not Registered";
						}
						
					}
					catch(e){
						// console.log(e)
					}
				},
				filter: true,
                headerClass: 'bold-header'
			},
			{
				headerName: "Resend Consent",
				field: "resend",
				resizable: true,
				width: 200,
				cellRenderer: ResendConsentRenderer,
                headerClass: 'bold-header'

			},
			// {
			// 	headerName: "Comment",
			// 	field: "comment",
			// 	resizable: true,
			// 	width: 130,
			// 	filter: true,
			// 	editable: true,
			// 	cellEditor: 'agSelectCellEditor',
			// 	cellEditorParams: {
			// 		values: [
			// 			'',
			// 			'Consent message not available',
			// 			'Consent approved - No confirmation message',
			// 			'Consent approved success',
			// 			'Already approved',
			// 			'Deactivated',
			// 			'Error in resend',
			// 			'Others',
			// 			'Issue in approval process'
			// 		],
			// 	},
			// },
			{
				headerName: "Resend Consent On",
				field: "resend_on",
				resizable: true,
				width: 200,
				filter: true,
				valueGetter: function (params) {
					try {
						if (params.data.resend_on != "" && params.data.resend_on != undefined) {
							return getHyphenDDMMMYYYYHHMM(params.data.resend_on);
						}
						else {
							return "";
						}
					}
					catch (e) {

					}
				},
				editable: false,
                headerClass: 'bold-header'
			},
			// {
			// 	headerName: "Username",
			// 	field: "user_name",
			// 	resizable: true,
			// 	width: 130,
			// 	editable: false,
			// 	filter: true,
            //     headerClass: 'bold-header'
			// },
			{
				headerName: "Transporter Name",
				field: "transporter_name",
				resizable:true,
				width: 160,
				filter: false,
				editable:false,
                headerClass: 'bold-header'
			},

			// {
			// 	headerName: "Consent Status",
			// 	field: "last_consent_status",
			// 	resizable: true,
			// 	width: 250,
			// 	editable: false,
			// 	valueGetter: function (params) {
			// 		try {
			// 			if (params.data.last_consent_status == 1) {
			// 				return "SIM_TRACKING_NOT_ENABLED";
			// 			}
			// 			else if (params.data.last_consent_status == 2) {
			// 				return "SIM_TRACKING_NUMBER_NOT_UPDATED";
			// 			}
			// 			else if (params.data.last_consent_status == 3) {
			// 				return "SIM_TRACKING_ACTIVATED";
			// 			}
			// 			else if (params.data.last_consent_status == 4) {
			// 				return "SIM_TRACKING_DEACTIVATED";
			// 			}
			// 			else if (params.data.last_consent_status == 5) {
			// 				return "SIM_TRACKING_SENT_CONSENT";
			// 			}
			// 			else if (params.data.last_consent_status == 6) {
			// 				return "SIM_TRACKING_PENDING_FOR_CONSENT_APPROVAL";
			// 			}
			// 			else if (params.data.last_consent_status == 7) {
			// 				return "SIM_TRACKING_CONSENT_ACCEPTED";
			// 			}
			// 			else if (params.data.last_consent_status == 8) {
			// 				return "SIM_TRACKING_CONSENT_DECLINED_FIRST_TIME";
			// 			}
			// 			else if (params.data.last_consent_status == 9) {
			// 				return "SIM_TRACKING_ENABLED";
			// 			}
			// 			else if (params.data.last_consent_status == 10) {
			// 				return "SIM_TRACKING_CONSENT_DECLINED_ON_TRIP";
			// 			}
			// 			else if (params.data.last_consent_status == 11) {
			// 				return "SIM_TRACKING_REGISTERED";
			// 			}
			// 			else if (params.data.last_consent_status == 12) {
			// 				return "SIM_TRACKING_DEREGISTERED";
			// 			}
			// 			else if (params.data.last_consent_status == 13) {
			// 				return "SIM_TRACKING_ERROR";
			// 			}
			// 			else if (params.data.last_consent_status == 14) {
			// 				return "SIM_TRACKING_REQUESTED_REGISTRATION";
			// 			}
			// 			else if (params.data.last_consent_status == 15) {
			// 				return "SIM_TRACKING_REQUESTED_DE_REGISTRATION";
			// 			}
			// 			else if (params.data.last_consent_status == 16) {
			// 				return "SIM_TRACKING_REQUESTED_ACTIVATION";
			// 			}
			// 			else if (params.data.last_consent_status == 17) {
			// 				return "SIM_TRACKING_REQUESTED_DE_ACTIVATION";
			// 			}
			// 			else if (params.data.last_consent_status == 18) {
			// 				return "SIM_TRACKING_REQUESTED_LOCATION";
			// 			}
			// 			else if (params.data.last_consent_status == 19) {
			// 				return "SIM_TRACKING_ACTIVATION_FAILED";
			// 			}
			// 			else if (params.data.last_consent_status == 20) {
			// 				return "SIM_TRACKING_DE_ACTIVATION_FAILED";
			// 			}
			// 			else if (params.data.last_consent_status == 21) {
			// 				return "SIM_TRACKING_DE_REGISTRATION_FAILED";
			// 			}
			// 			else if (params.data.last_consent_status == 22) {
			// 				return "SIM_TRACKING_REGISTRATION_FAILED";
			// 			}
			// 		}
			// 		catch (e) {
			// 		}
			// 	},
			// 	filter: true
			// },
			

			// {
			// 	headerName: "Attended On",
			// 	field: "mark_as_verified_on",
			// 	resizable: true,
			// 	width: 150,
			// 	filter: true,
			// 	valueGetter: function (params) {
			// 		try {
			// 			if (params.data.mark_as_verified_on != "" && params.data.mark_as_verified_on != undefined) {
			// 				return getHyphenDDMMMYYYYHHMM(params.data.mark_as_verified_on);
			// 			}
			// 			else {
			// 				return "";
			// 			}
			// 		}
			// 		catch (e) {

			// 		}
			// 	},
			// 	editable: false
			// },

			// {
			// 	headerName: "Commented On",
			// 	field: "commented_on",
			// 	resizable: true,
			// 	width: 150,
			// 	filter: true,
			// 	valueGetter: function (params) {
			// 		try {
			// 			if (params.data.commented_on != "" && params.data.commented_on != undefined) {
			// 				return getHyphenDDMMMYYYYHHMM(params.data.commented_on);
			// 			}
			// 			else {
			// 				return "";
			// 			}
			// 		}
			// 		catch (e) {

			// 		}
			// 	},
			// 	editable: false
			// },

			{
				headerName: "Created On",
				field: "created_date",
				resizable: true,
				width: 150,
				filter: true,
				valueGetter: function (params) {
					try {
						if (params.data.created_date != "" && params.data.created_date != undefined) {
							return getHyphenDDMMMYYYYHHMM(params.data.created_date);
						}
						else {
							return "";
						}
					}
					catch (e) {

					}
				},
				editable: false,
                headerClass: 'bold-header'
			},

			// {
			// 	headerName: "Modified On",
			// 	field: "modified_on",
			// 	resizable: true,
			// 	width: 150,
			// 	filter: true,
			// 	valueGetter: function (params) {
			// 		try {
			// 			if (params.data.modified_on != "" && params.data.modified_on != undefined) {
			// 				return getHyphenDDMMMYYYYHHMM(params.data.modified_on);
			// 			}
			// 			else {
			// 				return "";
			// 			}
			// 		}
			// 		catch (e) {

			// 		}
			// 	},
			// 	editable: false,
            //     headerClass: 'bold-header'
			// },
			// {
			// 	headerName: "JIO Status",
			// 	field: "jio_status",
			// 	resizable: true,
			// 	width: 130,
			// 	editable: false,
			// 	filter: true
			// },
			// {
			// 	headerName: "Telenity Status",
			// 	field: "telenity_status",
			// 	resizable: true,
			// 	width: 130,
			// 	editable: false,
			// 	filter: true
			// },
		];
		// var updateShipmentColumns = [
        //     {
        //         headerName: "Truck No",
        //         field: "truck_no",
        //         width: 120,
        //         pinned: "left",
        //         valueGetter: function (params) {
        //             if (params.data.truck_no != undefined && params.data.truck_no != "") {
        //                 return params.data.truck_no;
        //             }
        //             else {
        //                 return "No Data From API";
        //             }
        //         }
        //     },
        //     {
        //         headerName: "Invoice No (API)",
        //         field: "invoice_no",
        //         width: 150,
        //     },
        //     {
        //         headerName: "Driver Name (API)",
        //         field: "driver_name",
        //         width: 140,
        //         editable: true, 
        //         cellEditorFramework: (props) => {
        //             // Store the original value in a ref to avoid re-renders
        //             const originalValueName = React.useRef(props.value);
        //             const [value, setValue] = React.useState(props.value);

        //             // Update value when the input changes
        //             const handleChange = (event) => {
        //                 const newValue = event.target.value;
        //                 // Ensure the value contains only alphabetic characters and spaces
        //                 if (/^[a-zA-Z\s]*$/.test(newValue)) {
        //                     setValue(newValue);
        //                 }
        //             };

        //             // Handle key down to allow only alphabetic characters, spaces, and backspace
        //             const handleKeyDown = (event) => {
        //                 const charCode = event.which ? event.which : event.keyCode;
        //                 if (
        //                     (charCode >= 65 && charCode <= 90) || // Uppercase alphabetic keys
        //                     (charCode >= 97 && charCode <= 122) || // Lowercase alphabetic keys
        //                     charCode === 8 || // Backspace key
        //                     charCode === 32 // Space key
        //                 ) {
        //                     return;
        //                 } else {
        //                     event.preventDefault();
        //                 }
        //             };

        //             // Update the cell value and stop editing
        //             const onBlur = () => {
        //                 if (value !== originalValueName.current) {
        //                     props.node.setDataValue(props.column.colId, value);
        //                     props.api.stopEditing();
        //                 }
        //             };

        //             // Optional: You might want to handle key press 'Enter' to save changes
        //             const handleKeyPress = (event) => {
        //                 if (event.key === 'Enter') {
        //                     onBlur();
        //                 }
        //             };

        //             return (
        //                 <input
        //                     type="text"
        //                     value={value}
        //                     onChange={handleChange}
        //                     onKeyDown={handleKeyDown}
        //                     onBlur={onBlur}
        //                     onKeyPress={handleKeyPress}
        //                     style={{ width: '100%' }}
        //                     autoFocus // Automatically focus the input when editing starts
        //                 />
        //             );
        //         }
        //     },
        //     {
        //         headerName: "Driver Mobile No (API)",
        //         field: "driver_mobile_no",
        //         width: 140,
        //         editable: true,
        //         cellEditorFramework: (props) => {
        //             // Store the original value in a ref to avoid re-renders
        //             const originalValueRef = React.useRef(props.value);
        //             const [value, setValue] = React.useState(props.value);
            
        //             // Update value when the input changes
        //             const handleChange = (event) => {
        //                 const newValue = event.target.value;
        //                 // Ensure the value is numeric
        //                 if (/^\d*$/.test(newValue)) {
        //                     setValue(newValue);
        //                     this.setState({ originalValue: originalValueRef.current });
        //                 }
        //             };
            
        //             // Handle key down to allow only numeric values and backspace
        //             const handleKeyDown = (event) => {
        //                 const charCode = event.which ? event.which : event.keyCode;
        //                 if (
        //                     (charCode >= 48 && charCode <= 57) || // Numeric keys
        //                     charCode === 8 // Backspace key
        //                 ) {
        //                     return;
        //                 } else {
        //                     event.preventDefault();
        //                 }
        //             };
            
        //             // Update the cell value and stop editing
        //             const onBlur = () => {
        //                 if (value !== originalValueRef.current) {
        //                     props.node.setDataValue(props.column.colId, value);
        //                     props.api.stopEditing();
        //                 }
        //             };
            
        //             // Optional: You might want to handle key press 'Enter' to save changes
        //             const handleKeyPress = (event) => {
        //                 if (event.key === 'Enter') {
        //                     onBlur();
        //                 }
        //             };
            
        //             return (
        //                 <input
        //                     type="text"
        //                     value={value}
        //                     onChange={handleChange}
        //                     onKeyDown={handleKeyDown}
        //                     onBlur={onBlur}
        //                     onKeyPress={handleKeyPress}
        //                     style={{ width: '100%' }}
        //                 />
        //             );
        //         }
        //     },
        //     {
		// 		headerName: "Update",
		// 		field: "_id",
		// 		width: 100,
		// 		cellRenderer: 'UpdateShipments'

		// 	},
        // ]
		var columnwithdefsForSimLogs = [
			{
				headerName: "Mobile No",
				field: "mobile_no",
				width: 120,
				filter: true,
				resizable: true,
				sortable:true,
                headerClass: 'bold-header'
			},
			{
				headerName: "Actual Consent Status",
				field: "actual_consent_status",            
				width: 150,
				filter: true,
				resizable: true,
				sortable:true,
				hide:true,
                headerClass: 'bold-header'
			},
			{
				headerName: "Consent Status",
				field: "processed_consent_status",            
				width: 150,
				filter: true,
				resizable: true,
				sortable:true,
                headerClass: 'bold-header'
			},
			// {
			// 	headerName: "Expected Entity Status",
			// 	field: "expected_entity_status",            
			// 	width: 150,
			// 	filter: true,
			// 	resizable: true,
			// 	sortable:true,
			// },
			{
				headerName: "Consent Created at Service Provider",
				field: "consent_created_date_at_telenity",
				width: 200,
				filter: true,
				resizable: true,
				sortable:true,
				valueGetter:function(params){
					if(params.data.consent_created_date_at_telenity !=undefined && params.data.consent_created_date_at_telenity !="")
					{
						return getHyphenDDMMYYYYHHMMSS(params.data.consent_created_date_at_telenity);
					}
					else
					{
						return "";
					}
				},
                headerClass: 'bold-header'
			},
			// {
			// 	headerName: "Source From",
			// 	field: "source_from",
			// 	width: 150,
			// 	filter: true,
			// 	resizable: true,
			// 	sortable:true,
			// },
			{
				headerName: "Source Type",
				field: "source_type",
				width: 150,
				filter: true,
				resizable: true,
				sortable:true,
                headerClass: 'bold-header'
			},
			{
				headerName: "Created Date",
				field: "created_date",
				width: 150,
				filter: true,
				resizable: true,
				sortable:true,
                headerClass: 'bold-header',
				valueGetter:function(params){
					if(params.data.created_date !=undefined && params.data.created_date !="")
					{
						return getHyphenDDMMYYYYHHMMSS(params.data.created_date);
					}
					else
					{
						return "";
					}
				}
			},
			{
				headerName: "Modified Date",
				field: "modified_date",
				width: 150,
				filter: true,
				resizable: true,
				sortable:true,
				valueGetter:function(params){
					if(params.data.modified_date !=undefined && params.data.modified_date !="")
					{
						return getHyphenDDMMYYYYHHMMSS(params.data.modified_date);
					}
					else
					{
						return "";
					}
				},
                headerClass: 'bold-header'
			},
		]

		return (
			<div className="container-fluid">
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					onConfirm={this.closeAlert}
				>
				</SweetAlert>
				<div className="row">
                <div className="col-sm-12">
                        <h5 className="f18 master-title">
							<i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>{this.state.pageTitle} </span>
							</h5>
                    </div>
            </div>
				{this.state.alert}
				<div className="row">
					<div className="row col-sm-12">
						<div className={"trucks-dropdown " + this.state.showTrucksList}>
							<ul>
								{listData}
							</ul>
						</div>
						<form className="row theme-form col-xl-12 col-lg-12" onSubmit={this.formHandler}>
							<div className="col-xl-3 col-lg-3 form-group">
								<input type="text" style={{ height: "37px" }} name="assigned_truck_no" id="inputTruck" placeholder="Search By Truck No" autoComplete="off" className="form-control" value={this.state.assigned_truck_no.value} 
								// onFocus={this.initalList.bind(this)} 
								onChange={this.changeHandlerForSearch} />
							</div>
							<p style={{marginTop:"10px"}}> OR </p>
							<div className="col-xl-3 col-lg-3 form-group">
								<input type="text" placeholder="Enter Mobile No" onChange={this.changeHandlerForSearch} value={this.state.mobile_no_find} id="mobile_no_find" name="mobile_no_find" className="form-control" autoComplete='off' />
							</div>
							<div className="col-xl-2 col-lg-2 form-group">
								<button type="submit" className="btn btn-info">Find</button>
								&nbsp;
								<button onClick={this.resetPageData} type="button" className="btn btn-default">Reset</button>
							</div>
							<div className="col-xl-4 col-lg-4 form-group"></div>
							{/* <div className="col-xl-3 col-lg-3 form-group">
								<select name="gps_status" id="gps_status" onChange={this.changeGPSStatus} className="form-control">
									<option value="">Filter By Consent Status</option>
									<option value="0">All</option>
									<option value="1">ACTIVE</option>
									<option value="2">NOT FOUND</option>
									<option value="3">PENDING</option>
								</select>
							</div> */}
						</form>
					</div>
				</div>
				<div className={""}>
                        <SIMTrackingCounters setCounter={this.CounterClick} data ={this.state.SIMCounters}/>
                    </div>
				<div className="row">
					<div className="col-xl-12 col-lg-12">
						<div className="card">
							<div className="card-header">
								 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {/* Left side content */}
                                    <h4 style={{ fontWeight: "600", fontSize: "18px" }}>
                                        {<>
                                                                                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                                                                                <span>
                                                                               {` ${this.state.counterActive}`}
                                                                                </span>
                                                                                </>
                                        }
                                    </h4>
									</div>
							</div>


							<div className="card-body">

								<div className="row">
									<div className="col-sm-12">
										<button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn savegrid-border-radius" onClick={this.onClickSaveGridState.bind(this)}> <i className="fa fa-save"></i> </button>
										<button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn resetgrid-border-radius" onClick={this.resetState.bind(this)}> <i className="fa fa-reply"></i> </button>

									</div>
								</div>

								<div id="myGrid" style={{ height: "450px", width: "100%" }} className="ag-theme-balham">


									<AgGridReact
										modules={this.state.modules}
										columnDefs={columnwithDefs}
										defaultColDef={this.state.defaultColDef}
										rowData={this.state.rowData}
										// rowSelection={this.state.rowSelection}
										enableCharts={false}
										// frameworkComponents={{attendedButtonRenderer: AttendedButtonRenderer}}
										//  paginationAutoPageSize={true}
										paginationPageSize={this.state.paginationPageSize}
										pagination={true}
										// enableRangeSelection={true}
										onGridReady={this.onGridReady1}
										onGridState={this.onGridState1}
										deleteRowHandler={this.deleteRowHandler}
										// onSelectionChanged={this.onSelectionChanged.bind(this)}
										// frameworkComponents={this.state.frameworkComponents}
										//editType={this.state.editType}
										stopEditingWhenGridLosesFocus={true}
										// floatingFilter={true}
										enableCellChangeFlash={true}
										suppressCellFlash={true}
										gridOptions={{
											context: { componentParent: this }
										}}
										onCellClicked={this.onCellClicked}
										//updateRowHandler={this.updateRowHandler}
										onCellEditingStopped={this.updateCellData.bind(this)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={"dataLoadpage " + (this.state.loadshow)}>
				</div>
				<div className={"dataLoadpageimg " + (this.state.loadshow)}>
					<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
				</div>
				<div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>

				<div className={"slide-r " + (this.state.sliderAddTransporter)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4 className="slide-r-title">
							Add Driver
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll.bind(this)} >X</span>
						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>
						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{ padding: '5px 0px', width: '100%', zIndex: '9999', }} >
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={this.saveDriverItem.bind(this)}>

								<div className="col-xl-12 col-lg-12 form-group">
									<label className="col-xl-12 col-lg-12" style={{marginLeft:"-15px"}}> Driver Name</label>
									<input type="text" placeholder="Enter Driver Name" onChange={this.changeHandler.bind(this)} value={this.state.driver_name} id="driver_name" name="driver_name" className="form-control" autoComplete='off'/>
								</div>

								{/* <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Code</label>
									<input type="text" placeholder="Enter Driver Code" onChange={this.changeHandler.bind(this)} value={this.state.driver_code} id="driver_code" name="driver_code" className="form-control" required />
								</div> */}

								<div className="col-xl-12 col-lg-12 form-group">
									<label className="col-xl-12 col-lg-12" style={{marginLeft:"-15px"}}> Driver Mobile Number<span style={{color:'red'}}>*</span></label>
									<input type="text" placeholder="Enter Mobile Number" onChange={this.changeMobileNoHandler} onBlur={this.OnBlurMobile.bind(this)} value={this.state.mobile_no} id="mobile_no" name="mobile_no" className="form-control" required autoComplete='off'/>
									{(this.state.err_mobile != "") ?
										<span style={{ fontSize: "11px", color: "#ff0000" }}>{this.state.err_mobile}</span>
										: ""}
								</div>
								<div className="row form-group" style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12"> Truck No<span style={{color:'red'}}>*</span></label>
									<Select
										className="col-sm-12"
										name="assigned_truck_no"
										id="assigned_truck_no"
										onChange={this.onChangeTruck.bind(this)}
										value={this.state.assigned_truck_no}
										options={this.state.truckslist}
										required={false}
									/>
								</div>
								<div className="row form-group"  style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12"> Transporter Name<span style={{color:'red'}}>*</span></label>
									<Select
										className="col-sm-12"
										name="transporter_name"
										id="transporter_name"
										onChange={this.onChangeTransporter.bind(this)}
										value={this.state.transporter_name}
										options={this.state.transporterslist}
										required={false}
									/>
								</div>
								{/* <div className="row form-group"  style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12"> SIM Operator</label>
									<Select
										className="col-sm-12"
										name="mobile_network"
										id="mobile_network"
										value={this.state.mobile_network}
										onChange={this.newFilter.bind(this, "mobile_network")}
										options={this.state.sim_tracking_service_provider}
										required={true}
									/>
								</div> */}
								{/* <div className="col-xl-12 col-lg-12 row form-group">
								<label className="col-xl-5 col-lg-5"> Is Active</label>
								<div className="col-sm-7">
									<input type="radio" onChange={this.changeHandler.bind(this)} value="1" id="is_active" name="is_active" required /> Yes&nbsp;
									<input type="radio" onChange={this.changeHandler.bind(this)} value="0" id="is_active" name="is_active" required /> No
								</div>
							</div> */}

								<div className="col-xl-12 col-lg-12 form-group">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
							</form>

						</div>
					</div>
				</div>

				<div className={"slide-r " + (this.state.sliderEditTransporter)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4 className="slide-r-title">
							Edit Driver
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll.bind(this)} >X</span>
						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>
						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{ padding: '5px 0px', width: '100%', zIndex: '9999', }} >
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={this.updateDriverItem.bind(this)}>

								<div className="col-xl-12 col-lg-12 form-group">
									<label className="col-xl-12 col-lg-12" style={{marginLeft:"-15px"}}> Driver Name</label>
									<input type="text" placeholder="Enter Driver Name" onChange={this.changeHandler.bind(this)} value={this.state.driver_name} id="driver_name" name="driver_name" className="form-control" />
								</div>

								{/* <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Code</label>
									<input type="text" placeholder="Enter Driver Code" onChange={this.changeHandler.bind(this)} value={this.state.driver_code} id="driver_code" name="driver_code" className="form-control" required />
								</div> */}

								<div className="col-xl-12 col-lg-12 form-group">
									<label className="col-xl-12 col-lg-12" style={{marginLeft:"-15px"}}> Driver Mobile Number</label>
									<input type="text" placeholder="Enter Mobile Number" onChange={this.changeMobileNoHandler} onBlur={this.OnBlurMobile.bind(this)} value={this.state.mobile_no} id="mobile_no" name="mobile_no" className="form-control"/>
									{(this.state.err_mobile != "") ?
										<span style={{ fontSize: "11px", color: "#ff0000" }}>{this.state.err_mobile}</span>
										: ""}
								</div>
								<div className="row form-group" style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12">Truck No</label>
									<Select
										className="col-sm-12"
										name="assigned_truck_no"
										id="assigned_truck_no"
										onChange={this.onChangeTruck.bind(this)}
										value={this.state.assigned_truck_no}
										options={this.state.truckslist}
										// required={true}
									/>
								</div>
								<div className="row form-group" style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12"> Transporter Name</label>
									<Select
										className="col-sm-12"
										name="transporter_name"
										id="transporter_name"
										onChange={this.onChangeTransporter.bind(this)}
										value={this.state.transporter_name}
										options={this.state.transporterslist}
										// required={false}
									/>
								</div>
								{/* <div className="row form-group" style={{paddingInline:"12px"}}>
									<label className="col-xl-12 col-lg-12"> SIM Operator</label>
									<Select
										className="col-sm-12"
										name="mobile_network"
										id="mobile_network"
										value={this.state.mobile_network}
										onChange={this.newFilter.bind(this, "mobile_network")}
										options={this.state.sim_tracking_service_provider}
										// required={true}
									/>
								</div> */}
								{/* <div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-5 col-lg-5"> Is Active</label>
									<div className="col-sm-7">
										<input type="radio" onChange={this.changeHandler.bind(this)} value="1" checked={(this.state.is_active == 1) ? true : false} id="is_active" name="is_active" /> Yes
										<input type="radio" onChange={this.changeHandler.bind(this)} value="0" checked={(this.state.is_active == 0) ? true : false} id="is_active" name="is_active" /> No
									</div>
								</div> */}
								<div className="col-xl-12 col-lg-12 form-group">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
							</form>

						</div>
					</div>
				</div>

				{/* <div className={"overlay-part " + (this.state.overlay)} onClick={this.onClickHideForForceClosure.bind(this)}></div> */}


				<div className={"slide-r " + (this.state.sliderForceCloseTranslate)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4>
							Select SIM Operator
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll.bind(this)} >X</span>

						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>

						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{ padding: '5px 0px', width: '100%', overflow: 'hidden', zIndex: '9999', height: "100em" }} >
							<div className="col-xl-12 co-xl-12">
								<div className="form-group col-xl-12 col-lg-12">
									<label> </label>
									<Select
										className="border-radius-0"
										isMulti={false}
										id="mobile_network"
										style={{ borderRadius: "0px" }}
										value={this.state.mobile_network}
										onChange={this.newFilter.bind(this, "mobile_network")}
										options={this.state.sim_tracking_service_provider}
										required={true}
									/>
								</div>	

								<div className="form-group col-xl-12 col-lg-12">
									<button type="submit" className="btn btn-success" onClick={this.handleSubmit.bind(this)}>Submit</button>
									{this.state.errmsg ? <p className="txt-danger">*Please select SIM Operator</p> : ""}
								</div>

							</div>

						</div>
					</div>
				</div>

				<div className={"slide-r " + (this.state.sliderForSimLogs)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4 className="slide-r-title">
							IVR Logs
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll.bind(this)} >X</span>

						</h4>
					</div>
					<div className="slide-r-body" style={{position:"relative"}}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div><div className={"row"} style={{padding:'5px 0px', width: '100%', zIndex:'9999',}} >
						<div id="myGrid" style={{ height: "100vh", width: "100%" , padding:"15px"}} className="ag-theme-balham">
								<AgGridReact
									modules={this.state.modules}
									columnDefs={columnwithdefsForSimLogs}
									defaultColDef={this.state.defaultColDef}
									rowData={this.state.sim_logs_data}
									enableCharts={false}
									paginationPageSize={this.state.paginationPageSize}
									statusBar={this.state.statusBar}
									sideBar={this.state.sideBar}
									pagination={true}
									onGridReady={this.onGridReady}
									onGridState={this.onGridState}
									deleteRowHandler={this.deleteRowHandler}
									detailCellRendererParams={this.state.detailCellRendererParams}
									enableCellChangeFlash={true}
									suppressCellFlash={true}
									gridOptions={{
										context: { componentParent: this }
									}}
									masterDetail={true}
									onCellClicked={this.onCellClicked}
									onCellEditingStopped={this.updateCellData.bind(this)}
								/>
							</div>

                        </div>
					</div>
				</div>
				
				{/* {this.state.sliderUpdateShipment != '' ?
					<div className={"slide-r " + (this.state.sliderUpdateShipment)} style={{ overflow: "auto" }}>
						<div className="slide-r-title">
							<h4>
								Update Shipments
								<span className="float-right closebtn" style={{ marginRight: "25px" }}
									onClick={this.onClickHideAll.bind(this)} >X</span>

							</h4>
						</div>
						<div className="slide-r-body" style={{ position: "relative" }}>

							<div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
								<div id="myGrid1" style={{ width: "100%", height: "95vh" }} className={"ag-theme-balham"}>
									<AgGridReact
										modules={this.state.modules}
										columnDefs={updateShipmentColumns}
										defaultColDef={this.state.defaultColDef}
										rowData={this.state.allShipmentRows}
										enableCharts={true}
										enableRangeSelection={true}
										autoGroupColumnDef={this.state.autoGroupColumnDef}
										onGridReady={this.onGridReady1}
										onGridState={this.onGridState1}
										statusBar={this.state.statusBar}
										sideBar={this.state.sideBar}
										paginationPageSize={this.state.paginationPageSize}
										pagination={true}
										// frameworkComponents={this.state.frameworkComponents}
										// detailCellRendererParams={this.state.detailCellRendererParams}
										stopEditingWhenGridLosesFocus={true}
										// enableCellChangeFlash={false}
										// rowClassRules={this.state.rowClassRules}
										gridOptions={{
											context: { componentParent: this }
										}}
										// masterDetail={true}
										getRowStyle={this.getRowStyle.bind(this)}
										// rowSelection={this.state.rowSelection}
										suppressRowClickSelection={false}
									// onPaginationChanged={this.resetPaginationSelection}

									/>
								</div>
							</div>
						</div>
					</div>
					: ""} */}

			</div>

		);
	}
}

function GetSortDescOrder(prop) {    
	return function(a, b) {    
		if (a[prop] < b[prop]) {    
			return 1;    
		} else if (a[prop] > b[prop]) {    
			return -1;    
		}    
		return 0;    
	}    
} 